import { layout as fetchLayout } from "@/lib/prismicio/layout"
import layoutJson from "@/lib/prismicio/prismic-layout.json"
import { PrefetchResult, usePrefetch } from "@jog/react-components"
import { PrismicLayoutJson } from "@jog/shared"

export function prefetchLayout(prefetch: PrefetchResult["prefetch"]) {
    return prefetch("layout", async (): Promise<PrismicLayoutJson> => {
        if (process.env.FILE_CACHE_STRATEGY === "fs") {
            return layoutJson as unknown as PrismicLayoutJson
        }
        return fetchLayout()
    })
}
export const useLayout = () => {
    const { data } = usePrefetch("layout")
    return data
}
